// src/router.tsx
import { createRouter as createTanStackRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

export function getRouter() {
  const router = createTanStackRouter({
    routeTree,
    scrollRestoration: true,
    defaultViewTransition: true,
    context: {
      auth: undefined!, // This will be set after we wrap the app in AuthContextProvider
    },
  });

  return router;
}
